import { c as _c } from "react/compiler-runtime";
import type { CoursePageSection } from "@repo/sanity-utils/query-types";
import { Typography } from "@repo/ui/aops-components/typography";
import { CourseButton } from "@/app/components/CourseLevelPage/CourseButton/CourseButton";
import { CourseTag } from "@/app/components/CourseLevelPage/CourseTag/CourseTag";
import { getDisabledPrimaryCTABody, getDisabledPrimaryCTAButtonLabel, getDisabledPrimaryCTAHeader, getDisabledPrimaryCTATag, getDisabledPrimaryCTATuitionHeader, getDisabledPrimaryCTATuitionPlaceholder } from "@/app/components/CourseLevelPage/CourseCTACard/PrimaryCTA/PrimaryCTAUtils";
import styles from "./PrimaryCTA.module.css";
interface DisabledPrimaryCTAProps {
  coursePageSection?: NonNullable<CoursePageSection>;
}

/**
 * Persistent primary CTA shown when modality/part selections are incomplete.
 * Button is disabled; schedules and pricing appear after selections above.
 */
export function DisabledPrimaryCTA(t0) {
  const $ = _c(39);
  const {
    coursePageSection
  } = t0;
  let t1;
  if ($[0] !== coursePageSection?.keyedCopy) {
    t1 = coursePageSection?.keyedCopy ?? [];
    $[0] = coursePageSection?.keyedCopy;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const keyedCopy = t1;
  let t2;
  if ($[2] !== keyedCopy) {
    t2 = getDisabledPrimaryCTATag(keyedCopy);
    $[2] = keyedCopy;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const tag = t2;
  let t3;
  if ($[4] !== keyedCopy) {
    t3 = getDisabledPrimaryCTAHeader(keyedCopy);
    $[4] = keyedCopy;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const header = t3;
  let t4;
  if ($[6] !== keyedCopy) {
    t4 = getDisabledPrimaryCTABody(keyedCopy);
    $[6] = keyedCopy;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const body = t4;
  let t5;
  if ($[8] !== keyedCopy) {
    t5 = getDisabledPrimaryCTATuitionHeader(keyedCopy);
    $[8] = keyedCopy;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const tuitionHeader = t5;
  let t6;
  if ($[10] !== keyedCopy) {
    t6 = getDisabledPrimaryCTATuitionPlaceholder(keyedCopy);
    $[10] = keyedCopy;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const tuitionPlaceholder = t6;
  let t7;
  if ($[12] !== keyedCopy) {
    t7 = getDisabledPrimaryCTAButtonLabel(keyedCopy);
    $[12] = keyedCopy;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const buttonLabel = t7;
  let t8;
  if ($[14] !== tag) {
    t8 = <CourseTag>{tag}</CourseTag>;
    $[14] = tag;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== header) {
    t9 = <Typography as="h3" variant="h3">{header}</Typography>;
    $[16] = header;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== body) {
    t10 = body && <Typography as="p" variant="body">{body}</Typography>;
    $[18] = body;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t8 || $[22] !== t9) {
    t11 = <div className={styles.ctaMessage}>{t8}{t9}{t10}</div>;
    $[20] = t10;
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== tuitionHeader) {
    t12 = <Typography as="p" variant="eyebrow" className={styles.tuitionLabel}>{tuitionHeader}</Typography>;
    $[24] = tuitionHeader;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== tuitionPlaceholder) {
    t13 = <Typography as="p" variant="h4" className={styles.tuitionPlaceholder}>{tuitionPlaceholder}</Typography>;
    $[26] = tuitionPlaceholder;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <div className={styles.ctaActionMessage}>{t12}{t13}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== buttonLabel) {
    t15 = <div className={styles.buttons}><CourseButton id="view-schedule-disabled-button" label={buttonLabel} disabled={true} className={styles.button} /></div>;
    $[31] = buttonLabel;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t14 || $[34] !== t15) {
    t16 = <div className={styles.ctaAction}>{t14}{t15}</div>;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t11 || $[37] !== t16) {
    t17 = <div className={styles.primaryCTA}>{t11}{t16}</div>;
    $[36] = t11;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
}